import type { HeaderBiddingConfig } from './types'

export const DEFAULT_HEADER_BIDDING_CONFIG: HeaderBiddingConfig = {
    timeout: 3000,
    bidders: [
        {
            bidder: 'ix',
            params: {
                siteId: '1208437',
            },
        },
        {
            bidder: 'bidscube',
            params: {
                placementId: '19512',
            },
        },
        {
            bidder: 'tappx',
            params: {
                tappxkey: 'pub-93521-desktop-7229',
                endpoint: 'zz43701pg',
                host: 'zz43701pg.pub.tappx.com/rtb/',
            },
        },
        {
            bidder: 'minutemedia',
            params: {
                org: '01k4t8eybjkj',
            },
        },
        {
            bidder: 'anzuExchange',
            params: {
                host: 'ads-o9bl1a.marketplace-anzu.io',
                adUnitId: 351204173,
                adUnitType: 'banner',
                publisherId: '815125546',
            },
        },
    ],
}
